export enum ImpersonationMode {
  IMPERSONATION_ACTIVE = 'impersonation-active',
  IMPERSONATION_NOT_AVAILABLE = 'impersonation-not-available',
  PROXYING_ITSELF = 'proxying-itself',
  DEALER_PROXYING_FARMER = 'dealer-proxying-farmer'
}